<template>
  <main class="page">
    <div class="page__scale-input">
      <AppScale :scale-options="pageScale.options"
                @set-scale="setPageScale"
      />
    </div>
    <div class="departments-settings" v-if="roleAccessSettings">
      <div class="settings-button" @click.stop="openSettingsModal">
        <svg class="gear-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.7411 9.21716L19.8633 9.61482L20.2747 9.67687L22.9728 10.0839V13.2714L20.2603 13.6761L19.865 13.7351L19.7334 14.1126C19.5708 14.5789 19.4009 14.9941 19.1808 15.3873L18.9775 15.7506L19.2171 16.091C19.745 16.841 20.3011 17.5132 20.8554 18.178C20.6576 18.4235 20.1098 19.0291 19.5297 19.5976C19.2214 19.8997 18.9203 20.175 18.673 20.3705C18.5673 20.4541 18.4814 20.515 18.4163 20.5555L16.332 18.9474L16.0005 18.6916L15.6275 18.8818C15.2126 19.0934 14.7692 19.2766 14.3278 19.417L13.9206 19.5465L13.8712 19.9708C13.858 20.0848 13.845 20.1983 13.8322 20.3113C13.7404 21.118 13.6513 21.901 13.4607 22.631H10.1973L9.78292 19.9464L9.72038 19.5412L9.32967 19.417C8.88107 19.2743 8.45395 19.1053 8.04534 18.897L7.67841 18.7099L7.34861 18.9566L5.21301 20.5543C5.18023 20.5251 5.14719 20.4956 5.11394 20.4659C4.32304 19.7606 3.40924 18.9456 2.84173 18.1926C3.06787 17.8924 3.30313 17.5969 3.54559 17.2924C3.56682 17.2657 3.58811 17.2389 3.60945 17.2121C3.88225 16.8693 4.16268 16.5151 4.43271 16.1471L4.68004 15.8101L4.48172 15.442C4.23821 14.9901 4.04161 14.5314 3.90259 14.0654L3.78186 13.6607L3.36395 13.6L0.669271 13.208V10.0189L3.38124 9.61645L3.78985 9.5558L3.91467 9.16203C4.05418 8.72192 4.23663 8.30539 4.46581 7.88177L4.6629 7.51746L4.42121 7.18107C3.89851 6.45358 3.34853 5.77402 2.79218 5.10594C2.9868 4.85956 3.53043 4.2577 4.11168 3.68991C4.4197 3.38902 4.72058 3.11523 4.9677 2.92097C5.06814 2.84202 5.15063 2.78342 5.21447 2.74328L7.31241 4.34694L7.64342 4.59997L8.01459 4.41069C8.42944 4.19915 8.87288 4.01592 9.31432 3.87553L9.72148 3.74604L9.77087 3.32165C9.78415 3.20759 9.79709 3.09391 9.80997 2.9807C9.90175 2.17417 9.99083 1.39135 10.1814 0.661458H13.4447L13.8591 3.34608L13.9217 3.75127L14.3124 3.87553C14.761 4.0182 15.1881 4.18717 15.5967 4.39553L15.9623 4.58193L16.2917 4.33724L18.4446 2.73785C18.512 2.79909 18.5802 2.86102 18.6492 2.92356C19.4121 3.61571 20.2571 4.38232 20.7951 5.1069C20.5705 5.40468 20.3371 5.69795 20.0965 6.00012C20.0753 6.0268 20.054 6.05355 20.0326 6.08038C19.7598 6.42318 19.4794 6.77738 19.2094 7.14539L18.962 7.48245L19.1604 7.85048C19.4041 8.30281 19.6016 8.76332 19.7411 9.21716ZM18.3296 20.6025C18.3296 20.6024 18.3317 20.6015 18.3358 20.6001C18.3316 20.602 18.3296 20.6026 18.3296 20.6025ZM5.31099 2.69038C5.31094 2.69049 5.3089 2.69139 5.30499 2.69272C5.30907 2.69094 5.31103 2.69027 5.31099 2.69038ZM11.821 16.1898C14.3463 16.1898 16.4202 14.1586 16.4202 11.6463C16.4202 9.13391 14.3463 7.10271 11.821 7.10271C9.29577 7.10271 7.22185 9.13392 7.22185 11.6463C7.22185 14.1586 9.29577 16.1898 11.821 16.1898Z"
            stroke-width="1.5" />
        </svg>
      </div>
      <transition name="fade">
        <DepartmentSettingsModal v-if="departmentSettings.active"
                                 :state="departmentSettings"
        />
      </transition>
    </div>
    <section class="structure" :style="`transform: scale(${pageScale.currentScale}); -webkit-transform: scale(${pageScale.currentScale}); -ms-transform: scale(${pageScale.currentScale});`"
             v-show="mainDepartment.id && mainDepartment.children && mainDepartment.direct_children">
      <div class="structure__title">
        <h1 class="title">Структура организации ООО "Промсервис"</h1>
      </div>
      <div class="structure__owner">
        <div class="structure__owner-item">
          <DepartmentCard :department="mainDepartment"
                          :is-controls-active="mainDepartment.isControlsActive"
                          :is-staff-list-active="mainDepartment.isStaffListActive"
                          :allow-controls="roleAccessControls"
                          :allowed-control-items="roleAccessControlItems"
                          @add-child-department="createChildDepartment"
                          @update-department="showUpdateDepartmentModal"
                          @remove-department="showRemoveConfirmation(mainDepartment.id)"
                          @toggle-controls="toggleItemControls(mainDepartment.id)"
                          @show-detail-modal="showDetailDepartmentModal"
          />
          <span class="structure__line vertical vertical_bottom" v-show="mainDepartment.children && mainDepartment.children.length !== 0"></span>
        </div>
      </div>
      <div class="structure__row">
        <!--дерево непосредственного подчинения владельцу-->
        <div class="direct-children-wrap" v-show="mainDepartment.direct_children && mainDepartment.direct_children.length !== 0">
          <span class="structure__line horizontal" :style="lines.directChildrenHorizontal"></span>
          <div class="structure__block" v-for="department in mainDepartment.direct_children" :key="department.id">
            <span class="structure__line vertical vertical_top"></span>
            <div :class="department.type === 4 ? 'structure__block-department' : 'structure__block-parent'">
              <DepartmentCard :department="department"
                              :is-controls-active="department.isControlsActive"
                              :is-staff-list-active="department.isStaffListActive"
                              :allow-controls="roleAccessControls"
                              :allowed-control-items="roleAccessControlItems"
                              @add-child-department="createChildDepartment"
                              @update-department="showUpdateDepartmentModal"
                              @remove-department="showRemoveConfirmation(department.id)"
                              @toggle-controls="toggleItemControls(department.id)"
                              @toggle-staff-list="toggleItemStaffList(department.id)"
                              @show-detail-modal="showDetailDepartmentModal"
              />
              <span class="structure__line vertical vertical_bottom" v-show="department.type === 3 && department.children && department.children.length !== 0"></span>
            </div>
            <!--если тип департамента "Отделение" и потомки должны строится горизонтально-->
            <div class="structure__block-children" v-if="department.type === 3">
              <div class="structure__block department-line" v-for="department in department.children" :key="department.id">
                <span class="structure__line vertical horizontal"></span>
                <span class="structure__line vertical vertical_top"></span>
                <div class="structure__block-department">
                  <DepartmentCard :department="department"
                                  :is-controls-active="department.isControlsActive"
                                  :is-staff-list-active="department.isStaffListActive"
                                  :allow-controls="roleAccessControls"
                                  :allowed-control-items="roleAccessControlItems"
                                  @add-child-department="createChildDepartment"
                                  @update-department="showUpdateDepartmentModal"
                                  @remove-department="showRemoveConfirmation(department.id)"
                                  @toggle-controls="toggleItemControls(department.id)"
                                  @toggle-staff-list="toggleItemStaffList(department.id)"
                                  @show-detail-modal="showDetailDepartmentModal"
                  />
                </div>
                <div class="structure__block-sections">
                  <div class="structure__block-sections__item" v-for="department in department.children" :key="department.id">
                    <DepartmentCard :department="department"
                                    :is-controls-active="department.isControlsActive"
                                    :is-staff-list-active="department.isStaffListActive"
                                    :allow-controls="roleAccessControls"
                                    :allowed-control-items="roleAccessControlItems"
                                    @add-child-department="createChildDepartment"
                                    @update-department="showUpdateDepartmentModal"
                                    @remove-department="showRemoveConfirmation(department.id)"
                                    @toggle-controls="toggleItemControls(department.id)"
                                    @toggle-staff-list="toggleItemStaffList(department.id)"
                                    @show-department-modal="showModal"
                                    @show-detail-modal="showDetailDepartmentModal"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="structure__block-sections" v-else>
              <div class="structure__block-sections__item" v-for="department in department.children" :key="department.id">
                <DepartmentCard :department="department"
                                :is-controls-active="department.isControlsActive"
                                :is-staff-list-active="department.isStaffListActive"
                                :allow-controls="roleAccessControls"
                                :allowed-control-items="roleAccessControlItems"
                                @add-child-department="createChildDepartment"
                                @update-department="showUpdateDepartmentModal"
                                @remove-department="showRemoveConfirmation(department.id)"
                                @toggle-controls="toggleItemControls(department.id)"
                                @toggle-staff-list="toggleItemStaffList(department.id)"
                                @show-department-modal="showModal"
                                @show-detail-modal="showDetailDepartmentModal"
                />
              </div>
            </div>
          </div>
        </div>
        <!--/дерево непосредственного подчинения владельцу-->

        <!--основное дерево дочерних-->
        <div class="structure__block main-children-wrap"
             v-for="department in mainDepartment.children"
             :class="mainDepartment.direct_children && mainDepartment.direct_children.length === 0 ? 'no-margin' : ''"
             :key="department.id">
          <span class="structure__line horizontal" v-show="mainDepartment.direct_children && mainDepartment.direct_children.length !== 0"></span>
          <span class="structure__line vertical vertical_top"></span>
          <div class="structure__block-parent">
            <DepartmentCard :department="department"
                            :is-controls-active="department.isControlsActive"
                            :is-staff-list-active="department.isStaffListActive"
                            :allow-controls="roleAccessControls"
                            :allowed-control-items="roleAccessControlItems"
                            @add-child-department="createChildDepartment"
                            @update-department="showUpdateDepartmentModal"
                            @remove-department="showRemoveConfirmation(department.id)"
                            @toggle-controls="toggleItemControls(department.id)"
                            @show-detail-modal="showDetailDepartmentModal"
            />
            <span class="structure__line vertical vertical_bottom" v-show="department.children && department.children.length !== 0"></span>
          </div>
          <div class="structure__block-children">
            <div class="structure__block main-tree-first-line" v-for="department in department.children" :key="department.id">
              <span class="structure__line horizontal"></span>
              <span class="structure__line vertical vertical_top"></span>
              <div class="structure__block-parent">
                <DepartmentCard :department="department"
                                :is-controls-active="department.isControlsActive"
                                :is-staff-list-active="department.isStaffListActive"
                                :allow-controls="roleAccessControls"
                                :allowed-control-items="roleAccessControlItems"
                                @add-child-department="createChildDepartment"
                                @update-department="showUpdateDepartmentModal"
                                @remove-department="showRemoveConfirmation(department.id)"
                                @toggle-controls="toggleItemControls(department.id)"
                                @show-detail-modal="showDetailDepartmentModal"
                />
                <span class="structure__line vertical vertical_bottom" v-show="department.children && department.children.length !== 0"></span>
              </div>
              <div class="structure__block-children">
                <div class="structure__block main-tree-second-line" v-for="department in department.children" :key="department.id">
                  <span class="structure__line horizontal"></span>
                  <span class="structure__line vertical vertical_top"></span>
                  <div class="structure__block-parent">
                    <DepartmentCard :department="department"
                                    :is-controls-active="department.isControlsActive"
                                    :is-staff-list-active="department.isStaffListActive"
                                    :allow-controls="roleAccessControls"
                                    :allowed-control-items="roleAccessControlItems"
                                    @add-child-department="createChildDepartment"
                                    @update-department="showUpdateDepartmentModal"
                                    @remove-department="showRemoveConfirmation(department.id)"
                                    @toggle-controls="toggleItemControls(department.id)"
                                    @toggle-staff-list="toggleItemStaffList(department.id)"
                                    @show-detail-modal="showDetailDepartmentModal"
                    />
                    <span class="structure__line vertical vertical_bottom" v-show="department.children && department.children.length !== 0"></span>
                  </div>
                  <div class="structure__block-children">
                    <div class="structure__block department-line" v-for="department in department.children" :key="department.id">
                      <span class="structure__line horizontal"></span>
                      <span class="structure__line vertical vertical_top"></span>
                      <div class="structure__block-department">
                        <DepartmentCard :department="department"
                                        :is-controls-active="department.isControlsActive"
                                        :is-staff-list-active="department.isStaffListActive"
                                        :allow-controls="roleAccessControls"
                                        :allowed-control-items="roleAccessControlItems"
                                        @add-child-department="createChildDepartment"
                                        @update-department="showUpdateDepartmentModal"
                                        @remove-department="showRemoveConfirmation(department.id)"
                                        @toggle-controls="toggleItemControls(department.id)"
                                        @toggle-staff-list="toggleItemStaffList(department.id)"
                                        @show-detail-modal="showDetailDepartmentModal"
                        />
                      </div>
                      <div class="structure__block-sections">
                        <div class="structure__block-sections__item" v-for="department in department.children" :key="department.id">
                          <DepartmentCard :department="department"
                                          :is-controls-active="department.isControlsActive"
                                          :is-staff-list-active="department.isStaffListActive"
                                          :allow-controls="roleAccessControls"
                                          :allowed-control-items="roleAccessControlItems"
                                          @add-child-department="createChildDepartment"
                                          @update-department="showUpdateDepartmentModal"
                                          @remove-department="showRemoveConfirmation(department.id)"
                                          @toggle-controls="toggleItemControls(department.id)"
                                          @toggle-staff-list="toggleItemStaffList(department.id)"
                                          @show-detail-modal="showDetailDepartmentModal"
                                          @show-department-modal="showModal"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/основное дерево дочерних-->
      </div>
    </section>

    <transition-group name="fade">
      <!--модалка структуры эмитит ивенты уже с id отдела-->
      <StructureModal v-if="modals.structure.active"
                      key="structure-modal"
                      :department="modals.structure.department"
                      :allow-controls="roleAccessControls"
                      :allowed-control-items="roleAccessControlItems"
                      @close-modal="closeModal"
                      @show-department-detail="showDetailDepartmentModal"
                      @update-department="showUpdateDepartmentModal"
                      @remove-department="showRemoveConfirmation"
                      @toggle-controls="toggleItemControls"
                      @toggle-staff-list="toggleItemStaffList"
                      @close-popups="closeItemsPopups"
      />
      <DepartmentUpdateModal v-if="modals.update.active"
                             key="department-update-modal"
                             :department="departmentForUpdate"
      />
      <DepartmentDetailModal v-if="modals.detail.active"
                             key="department-detail-modal"
                             :department="departmentForDetail"
      />
      <AppConfirmation v-if="removeConfirmation.active"
                       key="remove-confirmation-modal"
                       text="Вы действительно хотите удалить этот отдел?"
                       @confirm="removeDepartment"
                       @reject="closeRemoveConfirmation"
      />
    </transition-group>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import DepartmentCard from '../../components/page/user/DepartmentCard'
import StructureModal from '../../components/page/modal/StructureModal'
import DepartmentUpdateModal from '../../components/page/modal/DepartmentUpdateModal'
import AppConfirmation from '../../components/page/modal/AppConfirmation'
import ThePagePreloader from '../../components/page/ThePagePreloader'
import DepartmentDetailModal from '@/components/page/modal/DepartmentDetailModal'
import AppScale from '@/components/page/input/AppScale'
import DepartmentSettingsModal from '@/components/page/modal/DepartmentSettingsModal'

export default {
  name: 'DepartmentsTree',
  components: {
    DepartmentSettingsModal,
    AppScale,
    DepartmentDetailModal,
    ThePagePreloader,
    AppConfirmation,
    DepartmentUpdateModal,
    StructureModal,
    DepartmentCard
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        departmentId: null
      },
      // структурные связи
      lines: {
        directChildrenHorizontal: ''
      }
    }
  },
  computed: {
    pageScale () {
      return this.$store.getters.departmentsTreePageScale
    },
    departmentSettings () {
      return this.$store.getters.departmentsTreeSettings
    },
    mainDepartment () {
      return this.$store.getters.getMainDepartment
    },
    modals () {
      return this.$store.getters.departmentsTreeModals
    },
    departmentForUpdate () {
      return this.$store.getters.departmentForUpdate
    },
    departmentForDetail () {
      return this.$store.getters.departmentForDetail
    },
    isLoading () {
      return this.$store.getters.departmentsTreeIsLoading
    },

    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessControls () {
      return this.$store.getters.getRoleRightsUserDepartments.actionAccess
    },
    roleAccessControlItems () {
      return this.$store.getters.getRoleRightsUserDepartments.actions
    },
    roleAccessSettings () {
      return this.$store.getters.getRoleRightsUserDepartments.settings
    }
  },
  methods: {
    async loadOptions () {
      // геттеры по этим спискам используются в карточках отдела, поэтому нужно запросить списки
      await this.$store.dispatch('[dictionaries] getStatusList')
      await this.$store.dispatch('[dictionaries] getPositionList')
    },
    setPageScale (optionId) {
      this.$store.dispatch('setDepartmentTreePageScale', optionId)
    },
    showModal (department) {
      this.$store.dispatch('showDepartmentTreeModal', department)
    },
    closeModal () {
      this.$store.dispatch('closeDepartmentTreeModal')
    },
    showDetailDepartmentModal (department) {
      this.$store.dispatch('showDetailDepartmentModal', department)
    },
    createChildDepartment (parent) {
      this.$store.dispatch('setNewDepartmentParent', parent)
      this.$router.push({ path: '/departments/create' })
    },
    showUpdateDepartmentModal (department) {
      this.$store.dispatch('showUpdateDepartmentModal', department)
    },
    showRemoveConfirmation (departmentId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.departmentId = departmentId
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.departmentId = null
    },
    removeDepartment () {
      this.$store.dispatch('removeDepartment', this.removeConfirmation.departmentId)
      this.closeRemoveConfirmation()
    },
    toggleItemControls (departmentId) {
      this.$store.dispatch('toggleDepartmentsTreeItemControls', departmentId)
    },
    toggleItemStaffList (departmentId) {
      this.$store.dispatch('toggleDepartmentsTreeItemStaffList', departmentId)
    },
    closeItemsPopups () {
      this.$store.dispatch('closeDepartmentsTreeItemPopups')
    },
    openSettingsModal () {
      this.$store.commit('[department-tree] OPEN_SETTINGS_MODAL')
    }
  },
  mounted () {
    this.loadOptions().then(() => {
      this.$store.dispatch('getDepartments')
    })
  },
  updated () {
    /* корректируем ширину и отступ линии связи дочерних элементов прямого подчинения */
    if (this.mainDepartment.direct_children && this.mainDepartment.direct_children.length !== 0) {
      const directWrapWidth = parseInt(document.querySelector('.direct-children-wrap').offsetWidth)
      const directChildrenBlocks = document.querySelectorAll('.direct-children-wrap > .structure__block')
      /* ширина последнего блока в дереве непосредственного подчинения */
      const firstDirectChildWidth = parseInt(directChildrenBlocks[0].offsetWidth)

      // margin-right: 60px; отступ .main-children-wrap
      this.lines.directChildrenHorizontal = `width: ${directWrapWidth + 60}px; left: ${firstDirectChildWidth / 2}px;`
    }
  },
  beforeDestroy () {
    this.$store.dispatch('closeDepartmentTreeModal')
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/vars';
@import '../../assets/css/system/mixins';

.page {
  position: relative;

  &__scale-input {
    position: absolute;
    z-index: 2;
    top: 20px;
    left: 280px;
  }
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: $color__brown;
}

.subtitle {
  font-size: 18px;
  color: $color__brown;
}

.settings-button {
  position: absolute;
  z-index: 2;
  top: 60px;
  left: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  @include size(30px);
  user-select: none;
  cursor: pointer;
  color: $color__brown;
  opacity: .6;
  transition: .3s;

  @media screen and (min-width: $hover_enable_width) {
    &:hover {
      opacity: 1;
    }
  }
}

.structure {
  padding-top: 20px;
  padding-right: 500px;
  padding-bottom: 240px;
  width: max-content;
  transition: .3s;
  transform-origin: top left;

  &__title {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
  }

  &__line {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: $color__orange;
    display: block;

    &.vertical {
      width: 2px;
      height: 20px;
      margin: 0 auto;

      &_top {
        top: -20px;
      }

      &_bottom {
        top: 100%;
        bottom: -20px;
      }
    }

    &.horizontal {
      width: auto;
      height: 2px;
      top: -20px;
    }
  }

  &__owner {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    margin-bottom: 38px;
  }

  &__owner-item {
    position: relative;
  }

  .main-children-wrap {
    margin-right: 60px;

    &.no-margin {
      margin: 0;
    }

    &:first-child {
      .horizontal {
        left: 50%;
      }
    }

    .horizontal {
      // ширина 100% + 2 отступа по 60px
      width: calc(100% + 120px);
      left: auto;
      right: 0;
    }

    // самая верхняя горизонтальная линия основного дерева
    > .horizontal {
      width: calc(100% + 60px);
      left: 0;
      right: auto;
    }

    &:last-child {
      > .horizontal {
        width: 50%;
      }
    }
  }

  &__row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }

  &__block {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }

    &.main-tree-first-line {
      &:first-child {
        .horizontal {
          width: 50%;
        }
      }

      &:not(:first-child) {
        .horizontal {
          width: calc(100% + 40px);
          left: auto;
          right: auto;
        }
      }

      &:last-child {
        .horizontal {
          // половина блока + 20px отступ
          width: calc(50% + 20px);
          left: auto;
          right: 50%;
        }
      }

      &:only-child {
        .horizontal {
          display: none;
        }
      }
    }

    &.main-tree-second-line {
      &:first-child {
        .horizontal {
          // половина блока + 20px отступ
          display: block;
          width: calc(50% + 20px);
          left: 50%;
        }
      }

      &:not(:first-child) {
        .horizontal {
          display: block;
          width: calc(100% + 40px);
          left: auto;
          right: auto;
        }
      }

      &:last-child {
        .horizontal {
          // половина блока + 20px отступ
          display: block;
          width: calc(50% + 20px);
          left: auto;
          right: 50%;
        }
      }

      &:only-child {
        > .horizontal {
          display: none;
        }
      }
    }

    &.department-line {
      &:first-child {
        .horizontal {
          // половина блока + 20px отступ
          left: 50%;
          width: calc(50% + 20px);
        }
      }

      &:not(:first-child) {
        .horizontal {
          width: calc(100% + 40px);
          left: auto;
          right: auto;
        }
      }

      &:last-child {
        .horizontal {
          // половина блока + 20px отступ
          width: calc(50% + 20px);
          left: auto;
          right: 50%;
        }
      }

      &:only-child {
        .horizontal {
          display: none;
        }
      }
    }
  }

  &__block-parent {
    position: relative;
    margin-bottom: 38px;
  }

  &__block-department {
    position: relative;
  }

  &__block-children {
    display: flex;
    flex-flow: row nowrap;
  }

  &__block-sections {
    &__item {
      &:not(:last-child) {
        .department-card_section {
          border-bottom: none;
        }
      }
    }
  }

  .direct-children-wrap {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    margin-right: 40px;
  }
}
</style>
